// src/utils/RequireAuth.jsx
import { Outlet } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import NotFoundPage from '../pages/404'

export default function RequireAuth() {
  const { isAuthenticated, getCookie } = useAuthContext()
  const hasToken = !!getCookie?.('token')

  if ((isAuthenticated === null || isAuthenticated === undefined) && hasToken) {
    return null
  }

  if (!isAuthenticated && !hasToken) {
    return <NotFoundPage />
  }

  return <Outlet />
}
